document.addEventListener('DOMContentLoaded', () => {
  Alpine.start();
})

document.addEventListener('turbo:load', () => {
  SlimSelect.init();
})

document.addEventListener('turbo:before-fetch-request', e => {
  const target = e.target;
  if (target?.dataset?.skipLoader === 'true') return;

  Loader.show(e);
})
